export enum FCParamValueType {
DateTime,
Numeric,
String,
}
